import {Pipe, PipeTransform} from '@angular/core';
import {Race} from "@model";

@Pipe({
    name: 'startedRaces',
    standalone: false
})
export class StartedRacesPipe implements PipeTransform {

  transform(raceList: Race[]): Race[] {
    return raceList.filter(race => {
      return race.raceStartItems?.some(item =>
        !!item.type ||
        !!item.started ||
        !!item.blockNumber ||
        !!item.selected  ||
        !!item.edited
      );
    });
  }
}
